import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { loadEmployeeNotifications } from './actions/load-employee-notifications';
import { employeeNotificationsForOrgIdSelector } from '../reducers/employee-selectors';

import { FeatureFlagged, FeatureGatedVariant } from '../feature-gates/feature-flagged';
import { FeatureGates } from '../feature-gates/feature-gates';
import { UiButton } from '../ui/ui-button';
import { UiMessageBanner } from '../ui/ui-message-banner';
import { orgSettingsRoute } from '../web-routes';

import Message from '../widgets/legacy-message';

const mapStateToProps = (state: any, ownProps: InputProps) => ({
  notifications: employeeNotificationsForOrgIdSelector(state, ownProps.orgId),
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  ownProps: InputProps,
) => ({
  actions: {
    loadEmployeeNotifications: () => dispatch(loadEmployeeNotifications(ownProps.orgId)),
  },
});

type InputProps = {
  orgId: number;
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & StateProps & DispatchProps & RouteComponentProps<{}>;

const EmployeeNotificationsWarningComponent = ({
  actions,
  notifications,
  orgId,
  history,
}: Props) => {
  useEffect(() => {
    actions.loadEmployeeNotifications();
  });

  const handleSetupClick = () => {
    history.push(orgSettingsRoute(orgId));
  };

  if (!notifications || notifications.length !== 0) {
    return null;
  }

  return (
    <>
      <FeatureFlagged
        variant={FeatureGatedVariant.HIDE_ON_FLAG}
        flagName={FeatureGates.INTEGRATED_MESSAGING}
      >
        <Message variant="warning">
          You have no notifications set up for incoming messages.&nbsp;
          <UiButton onClick={handleSetupClick}>Set up</UiButton>
        </Message>
      </FeatureFlagged>
      <FeatureFlagged
        variant={FeatureGatedVariant.SHOW_ON_FLAG}
        flagName={FeatureGates.INTEGRATED_MESSAGING}
      >
        <UiMessageBanner
          variant="attention"
          message="You have no notifications set up for incoming messages"
          action={{ name: 'Set Up', handler: handleSetupClick }}
        />
      </FeatureFlagged>
    </>
  );
};

export const EmployeeNotificationsWarning = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EmployeeNotificationsWarningComponent),
);
